const scholarshipApi = {
  GETSCHOLARSHIPRULES: 'CSVPA-China/api/scholarshipRules/getListByStudentId', //奖励
  GETPUNISHMENTRULES: 'CSVPA-China/api/punishmentRules/getListByStudentId', //惩罚
  SAVESCHOLARSHIP: 'CSVPA-China/api/scholarship/save', //增加奖励
  SAVEPUNISHMENT: 'CSVPA-China/api/punishment/save', //增加惩罚
  GETSCHOLARSHIPRECORD: 'CSVPA-China/api/scholarship/getListByStudentId', // 奖励记录
  GETPUNISHMENTRECORD: 'CSVPA-China/api/punishment/getListByStudentId' //惩罚记录
}

export default scholarshipApi
